import productResultPageGuts from './fragments/productResultPageGuts.fragment'
import productResultPageProductsFragment from './fragments/productResultPageProducts.fragment'
import searchResponseFacetsFragment from './fragments/searchResponseFacets.fragment'

const urlOnlyPagingQuery = /* GraphQL */ `
  query getPage(
    $url: String
    $searchProvider: String
    $skippedCriticalAttributes: [Int!] = null
    $fetchPrecedingPages: Boolean
    $fitmentCookieJson: String = null
  ) {
    productResultPageFromUrlOnly(
      url: $url
      searchProvider: $searchProvider
      skippedCriticalAttributes: $skippedCriticalAttributes
      fetchPrecedingPages: $fetchPrecedingPages
      fitmentCookieJson: $fitmentCookieJson
    ) {
      nextUrl
      currentPage
      ...productResultPageProductsFragment
    }
  }

  ${productResultPageProductsFragment}
`

const allPageFacetsUrlOnlyQuery = /* GraphQL */ `
  query getLinks($url: String, $skippedCriticalAttributes: [Int!] = null, $fitmentCookieJson: String = null) {
    allPageFacetsByURLOnly(
      url: $url
      skippedCriticalAttributes: $skippedCriticalAttributes
      fitmentCookieJson: $fitmentCookieJson
    ) {
      searchResponseFacets {
        ...searchResponseFacetsFragment
      }
      success
    }
  }

  ${searchResponseFacetsFragment}
`

const urlOnlyQuery = /* GraphQL */ `
  query getPage(
    $url: String
    $skippedCriticalAttributes: [Int!] = null
    $lazyLoadFacets: Boolean = null
    $fetchPrecedingPages: Boolean = null
    $fitmentCookieJson: String = null
  ) {
    productResultPageFromUrlOnly(
      url: $url
      skippedCriticalAttributes: $skippedCriticalAttributes
      lazyLoadFacets: $lazyLoadFacets
      fetchPrecedingPages: $fetchPrecedingPages
      fitmentCookieJson: $fitmentCookieJson
    ) {
      ...productResultPageGuts
    }
  }
  ${productResultPageGuts}
`

export { allPageFacetsUrlOnlyQuery, urlOnlyQuery, urlOnlyPagingQuery }
